import React from 'react';
import { Link } from 'react-router-dom';
import { ClipboardCheck, PlayCircle, Award } from 'lucide-react';

const StepsSection: React.FC = () => {
  const steps = [
    {
      icon: <ClipboardCheck size={40} className="text-[#2574B5]" />,
      title: "1. Anmelden",
      description: "Registrieren und Zahlungsmethode wählen"
    },
    {
      icon: <PlayCircle size={40} className="text-[#2574B5]" />,
      title: "2. Sehen & Lernen",
      description: "Direkt starten mit einem der 7 Lernmodule (Gesamtdauer ≈ 45 Min)"
    },
    {
      icon: <Award size={40} className="text-[#2574B5]" />,
      title: "3. Test & Zertifikat",
      description: "Abschlusstest machen und Zertifikat direkt erhalten (Mail oder PDF)"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              So einfach geht's – in 3 Schritten zum Ziel
            </h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {steps.map((step, index) => (
              <div 
                key={index}
                className="bg-gray-50 rounded-lg p-8 text-center transition-all duration-300 hover:shadow-md hover:-translate-y-1"
              >
                <div className="flex justify-center mb-6">
                  {step.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-600">
                  {step.description}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center">
            <p className="text-2xl font-medium text-gray-700 mb-8">
              Starten Sie noch heute und werden Sie EU AI Act compliant!
            </p>
            <Link 
              to="/registrieren" 
              className="inline-block bg-[#EE7F01] hover:bg-orange-600 text-white font-medium py-4 px-10 rounded-lg text-xl transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
            >
              Jetzt Kurs starten
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StepsSection;